<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/transactionConfigList' }">合作产品期间路径</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <div>
                        <el-button size="small" plain @click="insert">新增</el-button>
                        <el-button size="small" plain @click="copy">复制</el-button>
                        <el-button size="small" plain @click="update">编辑</el-button>
                        <el-button size="small" plain @click="disable">禁用</el-button>
                        <el-button size="small" plain @click="del">删除</el-button>
                        <draggableDetail :draggable="{ data_name: 'transaction_config' }" @isErrshow="reload"></draggableDetail>
                    </div>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="data" class="details" label-width="auto">
                        <template>
                            <el-row v-for="(item_out, index_out) in colData" :key="index_out">
                                <el-col :span="12" v-for="(item, index) in item_out" :key="index">
                                    <el-form-item :label="item.title ? item.title + '：' : ''">
                                        <div
                                            class="read_only read_only_link"
                                            v-if="in_array(item.prop, ['demander', 'supplier', 'product', 'partner'])"
                                        >
                                            <span @click="toDetail(item.prop)">{{ data[item.prop] }}</span>
                                        </div>
                                        <el-input
                                            v-else
                                            v-model="data[item.prop]"
                                            class="flex_item_text"
                                            size="mini"
                                            readonly="readonly"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="明细列表" name="2">
                    <vTransactionConfigDetail v-if="flag" :postList="detailParams"></vTransactionConfigDetail>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { onDelete, in_array, processColumnDataToRowNew } from '@/js/common';
import vTransactionConfigDetail from '../../listComponent/basicdata/transactionConfigDetail/transactionConfigDetailComponent.vue';
import draggableDetail from '../../../common/DrawerDetail.vue';
export default {
    inject: ['reload'],
    name: 'transactionConfigDetail',
    components: {
        draggableDetail,
        vTransactionConfigDetail
    },
    data() {
        return {
            colData: [],
            activeNames: ['1', '2'],
            data: {},
            queryParams: {},
            detailParams: {},
            headerTitle: '合作产品期间路径详情',
            flag: false
        };
    },
    watch: {
        $route(to, from) {
            this.queryParams.rid = to.query.id;
            this.reload();
        }
    },
    beforeMount() {
        this.selectedColData(); //筛选列
        this.initQueryParams();
    },
    mounted() {
        this.initSubListParams();
        this.$nextTick(() => {
            this.getData(); //获取详情
            this.flag = true;
        });
    },
    methods: {
        in_array,
        initSubListParams() {
            // 职位列表
            this.detailParams.params = {
                config_rid: this.queryParams.rid
            };
        },
        toDetail(prop) {
            if (prop == 'demander' && this.data.demander_rid != '') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: this.data.demander_rid
                    }
                });
            } else if (prop == 'product' && this.data.product_rid != '') {
                this.$router.push({
                    path: '/productListDetails',
                    query: {
                        id: this.data.product_rid
                    }
                });
            } else if (prop == 'supplier' && this.data.supplier_rid != '') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: this.data.supplier_rid
                    }
                });
            } else if (prop == 'partner' && this.data.partner_rid != '') {
                this.$router.push({
                    path: '/partnerDetails',
                    query: {
                        id: this.data.partner_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        //筛选列
        selectedColData() {
            let colData = JSON.parse(localStorage.getItem('detailList')).transaction_config;
            processColumnDataToRowNew(colData, this);
        },
        //详情
        getData() {
            this.$api
                .transactionConfigDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    document.title = this.headerTitle + ':' + res.data.rid;

                    this.initSubListParams();
                })
                .catch((error) => {});
        },
        //新增
        insert() {
            this.$router.push({
                path: 'transactionConfigEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        //复制
        copy() {
            this.$router.push({
                path: 'transactionConfigEdit',
                query: {
                    type: 'copy',
                    id: this.data.rid
                }
            });
        },
        //编辑
        update() {
            this.$router.push({
                path: 'transactionConfigEdit',
                query: {
                    type: 'update',
                    id: this.data.rid
                }
            });
        },
        //删除
        del() {
            onDelete(this.data.id, this, 'transactionConfigDelete', this.data.code, 'transactionConfigList');
        },
        disable() {
            this.$confirm('您确定要禁用吗，禁用后不能重新开启？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.$api['transactionConfigDisable']({ rid: this.data.rid })
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功!',
                                    type: 'success'
                                });
                                this.reload();
                            }
                        })
                        .catch((error) => {});
                })
                .catch(() => {});
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>